module.exports = __webpack_public_path__ + "images/bookmark-filled-76521a63.svg";